<template>
  <div class="settings extensible-history">
    <b-tabs type="is-toggle" @input="loadExtensibleByType">
        <b-tab v-for="(extensibleType, index) in extensibleTypesArr" 
        :key="extensibleType.type+index" class="extensible-tab-content">
          <template slot="title">
              <i :class="extensibleType.icon"></i> {{extensibleType.title}}
          </template>
          <ExtensibleTypeView 
                      :type="extensibleType.type" 
                      :isQuestionnaire="extensibleType.isQuestionnaire" 
                      @show-extensible-type-chooser="showChooseType"
                      @template-send-as-sms="handleSendAsSMS"/>
        </b-tab>
    </b-tabs>
      <b-modal title="Send as SMS" hide-footer v-model="isSending">
        <keep-alive>
          <component
            :is="composeSMS"
            :isDialog="true"
            :contentToSend="contentToSend"
            :newsletters="newsletterOptions"
          ></component>
        </keep-alive>
      </b-modal>
  </div>
</template>

<script>
import Vue from "vue"
import ExtensibleTypeView from '@/components/extensible-sms/ExtensibleTypeView'
import {extensibleTypes} from '@/constants'
import { mapGetters, mapActions, mapState } from "vuex"
import composeSMS from '@/components/messages/ComposeSMS'

const extensibleTypesArr = [{type: 'text', title: 'Texts', icon: 'icon-note icons', isQuestionnaire: false},
                          {type: 'image', title: 'Images', icon: 'icon-picture icons', isQuestionnaire: false},
                          {type: 'audio', title: 'Audios', icon: 'icon-microphone icons', isQuestionnaire: false},
                          {type: 'video', title: 'Videos', icon: 'icon-film icons', isQuestionnaire: false},
                          {type: 'vote', title: 'Votes', icon: 'icon-like icons', isQuestionnaire: true},
                          {type: 'survey', title: 'Surveys', icon: 'icon-star icons', isQuestionnaire: true},
                          {type: 'poll', title: 'Polls', icon: 'icon-heart icons', isQuestionnaire: true}]

export default {
  name: 'ExtensibleHistory',
  components: {
    ExtensibleTypeView,
  },
  data () {
    return {
      extensibleTypesArr: extensibleTypesArr,
      extensibleTypes: extensibleTypes,
      isSending: false,
      composeSMS: composeSMS,
      contentToSend: '',
    }
  },
  computed: {
    ...mapState('extensibleSms', ['extensibles']),
    ...mapState('user', ['user']),
    ...mapState('newsletter', ['newsletters', 'nextPage']),
    newsletterOptions() {
      let newsletterOptions = []
      this.newsletters.forEach(function (newsletter, key) {
          newsletterOptions.push({ value: newsletter.id, label: `${newsletter.name} (${newsletter.total_subscribers})` });
      })
      return newsletterOptions
    },
  },
  methods: {
    showChooseType(type, isQuestionnaire) {
      this.$emit('show-extensible-type-chooser', type, isQuestionnaire)
    },
    ...mapActions('extensibleSms', [
        'fetchAll'
    ]),
    ...mapActions('newsletter', [
        'fetchNewsletters'
    ]),
    loadExtensibleByType: async function(index) {
      let dueReload = false
      switch (this.extensibleTypesArr[index].type) {
        case extensibleTypes.text:
          if (this.extensibles.texts <= 0) 
            dueReload = true
          break
        case extensibleTypes.image:
          if (this.extensibles.images <= 0) 
            dueReload = true
          break
        case extensibleTypes.audio:
          if (this.extensibles.audios <= 0) 
            dueReload = true
          break
        case extensibleTypes.video:
          if (this.extensibles.videos <= 0) 
            dueReload = true
          break
        case extensibleTypes.vote:
          if (this.extensibles.votes <= 0) 
            dueReload = true
          break
        case extensibleTypes.survey:
          if (this.extensibles.surveys <= 0) 
            dueReload = true
          break
        case extensibleTypes.poll:
          if (this.extensibles.polls <= 0) 
            dueReload = true
          break
      }

      if (dueReload) {
        await this.fetchAll({data: {uuid: this.user.uuid, type: this.extensibleTypesArr[index].type}})
      }
    },
    handleSendAsSMS: function(content) {
      this.contentToSend = content
      this.isSending = true
    }
  },
  created() {
    if (this.newsletters.length <= 0) {
      this.fetchNewsletters({page:this.nextPage})
    }
  },
}
</script>

<style>
  .extensible-history .nav-tabs{
    border-top: 0px !important;
  }

  .extensible-tab-content{
    padding: 0px !important;
  }
</style>

